<template>
  <div class="layout-wrap">
    <router-link :to="{ name: 'Home' }">
      <header-logo />
    </router-link>

    <div class="card">
      <img
        class="card-img"
        :src="imageSrc"
        :alt="imageAlt"
        :style="{ maxWidth: imageMaxWidth }"
      />
      <div class="card-title">
        {{ title }}
      </div>
      <div class="card-description">
        {{ description }}
      </div>
      <component
        :is="actionComponent"
        v-bind="actionProps"
        class="btn btn-primary"
      >
        {{ actionText }}
      </component>
    </div>
  </div>
</template>

<script setup>
import HeaderLogo from '@/components/HeaderLogo.vue'

defineProps({
  imageSrc: {
    type: String,
    required: true,
  },
  imageAlt: {
    type: String,
    required: true,
  },
  imageMaxWidth: {
    type: String,
    default: '200px',
  },
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  actionText: {
    type: String,
    required: true,
  },
  actionComponent: {
    type: String,
    default: 'a',
  },
  actionProps: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<style lang="less" scoped>
.layout-wrap {
  display: grid;
  align-self: center;
  background: #f0f0f0;
  text-align: center;

  width: 100vw;
  height: 100vh;

  .card {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 auto;
    padding: 74px 52px;
    max-width: 620px;
    max-height: 580px;
    border-radius: 8px;
    box-shadow: 0px 9px 18px 0px rgba(26, 26, 26, 0.08);
    background-color: #fff;

    &-img {
      margin-bottom: 36px;
    }

    &-title {
      margin-bottom: 12px;
      font-size: 32px;
      font-weight: 600;
      line-height: 120%;
    }

    &-description {
      margin-bottom: 24px;
      font-size: 20px;
      font-weight: 400;
      line-height: 140%;
    }

    a,
    button {
      display: flex;
      align-items: center;
      margin-bottom: 0;
      padding: 12px 20px;
      min-height: 38px;
    }
  }

  @media all and (max-width: 650px) {
    background-color: #fff;

    .header-logo {
      background-color: #fff;
    }

    .card {
      box-shadow: none;

      &-img {
        max-width: 200px !important;
      }
    }
  }
}
</style>
